import { Navbar, Intro, Works, Contact, Icon, Footer } from './Components/index';
import './App.css';
import { themeContext } from './Context';
import { useContext } from "react";

function App() {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div className="App" style={{ background: darkMode ? 'black' : '', color: darkMode ? 'white' : '' }}>
      <div className='Navbar'>
          <Navbar />
      </div>

      <div className='Intro'>
      <Intro />
      </div>

   <div className='Works'>
      <Works />
    </div>
    <div className='Contact'>
        <Contact />
    </div>
    <div className='Icon'>   
     <Icon />
</div>
<div className='Footer' style={{paddingTop:'1rem'}}>
    <Footer />
</div>

    </div>
  );
}

export default App;




